import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export abstract class IBootstrapWorkbookForOfflineService {
  // abstract isCacheWorkbookDetailServicesRequired(jobId: string): Observable<Boolean>;
  abstract cacheWorkbookDetailServices(jobId: string): Observable<any>;
}
